const Spacer = ({ className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 3"
      fill="none"
      preserveAspectRatio="none"
      className={`w-full h-[3px] ${className}`}
    >
      <path
        d="M1440 3C978.716 2.07 461.272 2.09 0 3V0C396.495 0.88 863.044 0.76 1260 0.37L1440 0V3Z"
        fill="#857D66"
      />
    </svg>
  )
}

export default Spacer
